export const ScreenBreakpoints = {
  Tiny: 'only screen and (max-width: 450px)',
  Small: 'only screen and (max-width: 750px)',
  Medium: 'only screen and (min-width: 751px) and (max-width: 900px)',
  MediumMin: 'only screen and (min-width: 751px)',
  Large: 'only screen and (min-width: 901px) and (max-width: 1280px)',
  LargeMin: 'only screen and (min-width: 901px)',
  MediumLargeMin: 'only screen and (min-width: 1100px)',
  ExtraLarge: 'only screen and (min-width: 1281px)',
} as const;
